import React from "react";

/* eslint-disable max-len */
export default function AdminGroupIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30">
            <defs>
                <clipPath id="a">
                    <path
                        data-name="\u9577\u65B9\u5F62 1698"
                        fill="#9c9c9c"
                        d="M0 0H30V24.522H0z"
                    />
                </clipPath>
            </defs>
            <g data-name="\u30B0\u30EB\u30FC\u30D7 550">
                <g data-name="\u30B0\u30EB\u30FC\u30D7 507">
                    <g
                        data-name="\u30B0\u30EB\u30FC\u30D7 506"
                        clipPath="url(#a)"
                        fill="#9c9c9c"
                        transform="translate(-40 -15) translate(40 18)"
                        opacity={0.996}
                    >
                        <path
                            data-name="\u30D1\u30B9 8123"
                            d="M11.965 15.568l.007-.007a6.667 6.667 0 00-.336-.379c-.844-.905-2.415-2.591-2.415-6.727 0-4.3 1.715-6.089 3.673-6.732A3.776 3.776 0 009.362 0C7.487 0 4.994.584 4.994 5.637c0 3.581 1.274 4.949 2.036 5.766.506.544 1.272 1.366.294 2.344a12.268 12.268 0 01-3.746 2.268C1.627 16.9.325 17.557 0 18.886h6.112a15.681 15.681 0 012.522-1.336 11.211 11.211 0 003.331-1.981"
                        />
                        <path
                            data-name="\u30D1\u30B9 8124"
                            d="M16.38 16.6a7.435 7.435 0 01-.5-1.014 8.459 8.459 0 01-.309-.918 12.053 12.053 0 01-.4-3.239c0-4.3 1.715-6.089 3.672-6.732a3.773 3.773 0 00-3.531-1.724h-.167a6.142 6.142 0 00-.712.052 4.523 4.523 0 00-.7.146c-1.454.431-2.8 1.731-2.8 5.435a9.55 9.55 0 00.581 3.534 6.166 6.166 0 00.482.964c.035.06.07.116.106.172a7.872 7.872 0 00.867 1.1 3.311 3.311 0 01.656.905 1.209 1.209 0 01-.362 1.437 12.252 12.252 0 01-3.746 2.269l-.113.051a24.42 24.42 0 00-1.445.705 6.526 6.526 0 00-1.076.705 2.618 2.618 0 00-.944 1.408h6.113a15.562 15.562 0 012.522-1.336l.158-.073c.492-.223.983-.454 1.453-.705a8.782 8.782 0 001.122-.705 5.349 5.349 0 00.6-.5l.008-.008a7.572 7.572 0 00-.336-.378 8.649 8.649 0 01-1.2-1.555"
                            transform="translate(-.31 -.155)"
                        />
                        <path
                            data-name="\u30D1\u30B9 8125"
                            d="M27.041 21.962a62.63 62.63 0 01-.705-.326 22.139 22.139 0 01-.938-.468 8.6 8.6 0 01-2.1-1.474 1.591 1.591 0 01-.409-.634 1.107 1.107 0 01.029-.768 3.223 3.223 0 01.673-.941c.762-.818 2.037-2.186 2.037-5.766 0-5.054-2.494-5.638-4.37-5.638h-.167a6.592 6.592 0 00-.712.053 4.526 4.526 0 00-.7.147c-1.454.431-2.8 1.73-2.8 5.435a9.574 9.574 0 00.581 3.534c.081.206.164.4.253.574s.187.342.282.494c.011.018.024.034.034.052a6.93 6.93 0 00.712.92c.06.064.12.134.176.191a3.321 3.321 0 01.656.906 1.211 1.211 0 01-.363 1.436c-.076.077-.165.136-.244.207a7.525 7.525 0 01-.912.705 18.559 18.559 0 01-2.59 1.357l-.113.052a27.82 27.82 0 00-1.446.7 6.617 6.617 0 00-1.075.705 2.611 2.611 0 00-.943 1.408H30.62c-.325-1.329-1.626-1.986-3.578-2.87"
                            transform="translate(-.621 -.31)"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
